import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);

    this.applyPromoPrice();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  applyPromoPrice = () => {
    const url = new URL(window.location.href);
    const promo = url.searchParams.get('promo');
    const isPromoActive = false; // 프로모션이 끝나면 false로 바꾼다 — 할인가 표시가 완전히 꺼진다

    if (!isPromoActive) return;
    if (promo !== 'overay') return;
    if (!window.location.pathname.includes('/products/overay-tune-quest3')) return;

    const priceContainer = this.querySelector('[ref="priceContainer"]');
    if (!priceContainer) return;

    const priceEl = priceContainer.querySelector('.price');
    if (!priceEl) return;

    const metaEl = priceContainer.querySelector('.promo-price-meta');
    const compareEl = priceContainer.querySelector('.compare-at-price');

    const promoPrice = metaEl?.dataset.promoPrice || '$69.00';
    const originalPrice =
      metaEl?.dataset.originalComparePrice ||
      priceEl.dataset.originalPrice ||
      '$75.00';

    priceEl.textContent = promoPrice;

    if (compareEl) {
      compareEl.textContent = originalPrice;
    } else if (!priceContainer.querySelector('.promo-compare-price')) {
      const compare = document.createElement('span');
      compare.className = 'compare-at-price promo-compare-price';
      compare.textContent = originalPrice;
      compare.style.marginLeft = '8px';
      compare.style.textDecoration = 'line-through';
      compare.style.opacity = '0.6';
      priceEl.insertAdjacentElement('afterend', compare);
    }
  };

  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }

    this.applyPromoPrice();
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
